import { setCurrentUser, setToken } from '../common'
import store from '@/store'

export default async (to, from, next) => {
  if (to.path === '/auth/login') {
    return next()
  }
  if (to.matched.some((record) => record.meta.loginRequired)) {
    const user = store.getters['auth/userAuth'] || (await store.dispatch('auth/getProfile'))
    if (user && user.id) {
      next()
    } else {
      setCurrentUser(null)
      setToken(null)
      store.commit('auth/setUserAuth', null)
      if (from.path !== '/auth/login') {
        next('/auth/login')
      } else {
        next(false)
      }
    }
  } else {
    next()
  }
}
